(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('ContextualHelpDialogController', ContextualHelpDialogController);

    function ContextualHelpDialogController($scope, $mdDialog, $mdMedia, $state, sfSetupPanel, flagsService, model, utils, $translate) {

        $scope.$mdMedia = $mdMedia;
        $scope.isGamifiedTrialEnabled = (flagsService.get('gamifiedTrial') === true);
        $scope.currentUser = model.me;

        $scope.helpTranslations = {
            'Apps & Integrations': $translate.instant('Apps & Integrations'),
            'Can I buy more email finder credits?': $translate.instant('Can I buy more email finder credits?'),
            'Can I change the order of my custom fields?': $translate.instant('Can I change the order of my custom fields?'),
            'Can I configure multiple pipelines?': $translate.instant('Can I configure multiple pipelines?'),
            'Can I connect multiple email addresses?': $translate.instant('Can I connect multiple email addresses?'),
            'Can I find email addresses for contacts in Salesflare?': $translate.instant('Can I find email addresses for contacts in Salesflare?'),
            'Can I insert an image in my workflow?': $translate.instant('Can I insert an image in my workflow?'),
            'Can I make different types of custom fields?': $translate.instant('Can I make different types of custom fields?'),
            'Can I pull my YouCanBook.Me meetings into Salesflare?': $translate.instant('Can I pull my YouCanBook.Me meetings into Salesflare?'),
            'Can I see my top lead sources in the insights?': $translate.instant('Can I see my top lead sources in the insights?'),
            'Can I snooze tasks in bulk?': $translate.instant('Can I snooze tasks in bulk?'),
            'Configure your Pipeline': $translate.instant('Configure your Pipeline'),
            'Create accounts': $translate.instant('Create accounts'),
            'Custom dashboards & reports': $translate.instant('Custom dashboards & reports'),
            'Custom fields': $translate.instant('Custom fields'),
            'Do my email contacts sync with Salesflare?': $translate.instant('Do my email contacts sync with Salesflare?'),
            'Do you have an API?': $translate.instant('Do you have an API?'),
            'Email tracking: How does it work?': $translate.instant('Email tracking: How does it work?'),
            'Email workflows': $translate.instant('Email workflows'),
            'Email workflows use cases': $translate.instant('Email workflows use cases'),
            'How and why does Salesflare suggest accounts?': $translate.instant('How and why does Salesflare suggest accounts?'),
            'How can I add leads while browsing?': $translate.instant('How can I add leads while browsing?'),
            'How can I connect a calendar?': $translate.instant('How can I connect a calendar?'),
            'How can I enable the “Recurring revenue” feature?': $translate.instant('How can I enable the “Recurring revenue” feature?'),
            'How can I keep notes?': $translate.instant('How can I keep notes?'),
            'How can I make custom dashboards & reports?': $translate.instant('How can I make custom dashboards & reports?'),
            'How can I use Salesflare to find new leads?': $translate.instant('How can I use Salesflare to find new leads?'),
            'Can I use Salesflare in my own language?': $translate.instant('Can I use Salesflare in my own language?'),
            'Can I use Salesflare in dark mode?': $translate.instant('Can I use Salesflare in dark mode?'),
            'How can I use Salesflare’s API with “Webhooks by Zapier”?': $translate.instant('How can I use Salesflare’s API with “Webhooks by Zapier”?'),
            'How do I add a custom lost reason on opportunities?': $translate.instant('How do I add a custom lost reason on opportunities?'),
            'How do I add a team member to all accounts?': $translate.instant('How do I add a team member to all accounts?'),
            'How do I add contacts to an account?': $translate.instant('How do I add contacts to an account?'),
            'How do I add users to my team?': $translate.instant('How do I add users to my team?'),
            'How do I best set up my sales pipeline?': $translate.instant('How do I best set up my sales pipeline?'),
            'How do I change my login email address?': $translate.instant('How do I change my login email address?'),
            'How do I change my password?': $translate.instant('How do I change my password?'),
            'How do I contact support?': $translate.instant('How do I contact support?'),
            'How do I create user groups?': $translate.instant('How do I create user groups?'),
            'How do I delete something?': $translate.instant('How do I delete something?'),
            'How do I fix my import file?': $translate.instant('How do I fix my import file?'),
            'How do I hide old opportunities?': $translate.instant('How do I hide old opportunities?'),
            'How do I import my data into Salesflare?': $translate.instant('How do I import my data into Salesflare?'),
            'How do I insert merge fields in my workflow?': $translate.instant('How do I insert merge fields in my workflow?'),
            'How do I manage my tags?': $translate.instant('How do I manage my tags?'),
            'How do I manually upload files to Accounts?': $translate.instant('How do I manually upload files to Accounts?'),
            'How do I set sales targets?': $translate.instant('How do I set sales targets?'),
            'How do I set up an email workflow?': $translate.instant('How do I set up an email workflow?'),
            'How do I set user permissions?': $translate.instant('How do I set user permissions?'),
            'How do I turn on Salesflare notifications?': $translate.instant('How do I turn on Salesflare notifications?'),
            'How do I use the link tracking feature?': $translate.instant('How do I use the link tracking feature?'),
            'How do accounts, contacts & opportunities relate?': $translate.instant('How do accounts, contacts & opportunities relate?'),
            'How do accounts, contacts and opportunities relate?': $translate.instant('How do accounts, contacts and opportunities relate?'),
            'How do tasks work?': $translate.instant('How do tasks work?'),
            'How does Salesflare billing work?': $translate.instant('How does Salesflare billing work?'),
            'How does Salesflare’s contact sync work?': $translate.instant('How does Salesflare’s contact sync work?'),
            'How does the website tracking work?': $translate.instant('How does the website tracking work?'),
            'How is expected revenue calculated?': $translate.instant('How is expected revenue calculated?'),
            'How to I add contacts to accounts?': $translate.instant('How to I add contacts to accounts?'),
            'Import data': $translate.instant('Import data'),
            'Insights dashboards': $translate.instant('Insights dashboards'),
            'Lead search': $translate.instant('Lead search'),
            'LinkedIn sidebar for Chrome': $translate.instant('LinkedIn sidebar for Chrome'),
            'Permissions': $translate.instant('Permissions'),
            'Subscribing to Salesflare': $translate.instant('Subscribing to Salesflare'),
            'The Pipeline Process': $translate.instant('The Pipeline Process'),
            'The basics': $translate.instant('The basics'),
            'What additional permissions do admins & managers have?': $translate.instant('What additional permissions do admins & managers have?'),
            'What are Tags and Custom Fields?': $translate.instant('What are Tags and Custom Fields?'),
            'What are predefined custom fields?': $translate.instant('What are predefined custom fields?'),
            'What are the regional settings used for?': $translate.instant('What are the regional settings used for?'),
            'What do the insights mean?': $translate.instant('What do the insights mean?'),
            'What does “# days until activity task” mean?': $translate.instant('What does “# days until activity task” mean?'),
            'What is included in the Pro plan?': $translate.instant('What is included in the Pro plan?'),
            'What is shared with my team in Salesflare?': $translate.instant('What is shared with my team in Salesflare?'),
            'What kind of Zapier integrations are possible?': $translate.instant('What kind of Zapier integrations are possible?'),
            'What’s a “customer” in Salesflare?': $translate.instant('What’s a “customer” in Salesflare?'),
            'Where can I find my invoices?': $translate.instant('Where can I find my invoices?'),
            'Where do the meetings from the calendar appear?': $translate.instant('Where do the meetings from the calendar appear?'),
            'Why am I asked to fill out a close date? What does it mean?': $translate.instant('Why am I asked to fill out a close date? What does it mean?'),
            'Why aren’t my Calendly meetings showing in Salesflare?': $translate.instant('Why aren’t my Calendly meetings showing in Salesflare?'),
            'Will I be charged VAT?': $translate.instant('Will I be charged VAT?'),
            'Will Salesflare remind me when to follow up?': $translate.instant('Will Salesflare remind me when to follow up?')
        };

        const SEPARATOR = '.';
        // We use a dot notation to specify parent states
        // Some states have parent 'main' but should be linked to an entity, in that case we annotated them with a dash
        let tempName = $state.current.name.replaceAll('-', SEPARATOR);

        if (this.help[tempName]) {
            $scope.help = this.help[tempName];
        }
        else {
            do {
                tempName = tempName.slice(0, Math.max(0, tempName.lastIndexOf(SEPARATOR)));
                if (this.help[tempName]) {
                    $scope.help = this.help[tempName];
                    break;
                }
            }
            while (tempName.includes(SEPARATOR));
        }

        $scope.showSetupPercentage = function () {

            return utils.showSetupPercentage($scope.currentUser);
        };

        $scope.getSetupCompletePercentage = function () {

            return $translate.instant('{{percentage}}% complete', { percentage: $scope.currentUser.setup_completion_percentage });
        };

        $scope.goToSetup = function () {

            $scope.close();

            if ($mdMedia('gt-sm')) {
                return sfSetupPanel.show();
            }

            return $state.go('setup');
        };

        $scope.close = function () {

            return $mdDialog.cancel();
        };
    }
})();
